import Vue from 'vue';
import VueResource from 'vue-resource';
import SearchModule from './vue/search/search-module.vue';
import SearchModuleExternal from './vue/search/search-module-external.vue';
import NotificationOrderForm from './vue/notification-manager/notification-order-form.vue';
import JobsComponent from './vue/jobs-component/jobs-component.vue';
import PeoplePosts from './vue/people-posts/people-posts.vue';

import RegularJS from './regular/main.js';

Vue.use(VueResource);
let RegularJSloaded = RegularJS();

if(document.getElementById('notification-order-form-modal__content')){
    new Vue({
        el: '#notification-order-form-modal__content',
        mounted : function () {
            RegularJSloaded
        },
        components : {
            NotificationOrderForm
        },
    });
}

if(document.getElementById('archive-container')){
    new Vue({
        el: '#archive-container',
        mounted : function () {
            RegularJSloaded
        },
        components : {
            SearchModule,
            SearchModuleExternal
        },
    });
}

if(document.getElementById('notification-order-form-manager')){
    new Vue({
        el: '#notification-order-form-manager',
        mounted : function () {
            RegularJSloaded
        },
        components : {
            NotificationOrderForm
        },
    });
}

if(document.getElementById('jobs-teaser')){
    new Vue({
        el: '#jobs-teaser',
        mounted : function () {
            RegularJSloaded
        },
        components : {
            JobsComponent
        },
    });
}

if(document.getElementById('people-posts')){
    new Vue({
        el: '#people-posts',
        mounted : function () {
            RegularJSloaded
        },
        components : {
            PeoplePosts
        },
    });
}



// WEBPACK FOOTER //
// ./js/main.js